import { ILandingPartner } from 'partner360/models/landing/ILandingPartner'
import { ILandingProcessedPlanningFetched } from 'partner360/models/landing/ILandingProcessedPlanningFetched'

interface IGetFoundProcess {
  searchValue: string
  partners: ILandingPartner[]
  processedPlannings: ILandingProcessedPlanningFetched[]
}

export const getFoundProcess = ({
  searchValue,
  partners,
  processedPlannings,
}: IGetFoundProcess) => {
  if (!searchValue) {
    return null
  }
  const foundProcess = partners.find(
    (el) =>
      el.PartnerId.includes(searchValue) ||
      el.LocationId?.includes(searchValue) ||
      el.PartnerName.includes(searchValue)
  )

  if (foundProcess) {
    return processedPlannings.find((el) => el.partnerId === foundProcess.PartnerId) || null
  }
  return null
}
